// 售后相关页面的路由
export default [
  {
    path: "work/WorkTally",
    name: "WorkTally",
    component: () => import("../pages/work/WorkTally"),
    meta: {
      title: "售后点货",
    },
  },
  {
    path: "work/WrongSendGoods",
    name: "WrongSendGoods",
    component: () => import("../pages/work/WrongSendGoods"),
    meta: {
      title: "错发调账商品列表",
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/work.js